import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=22132950&"
import script from "./ReportForm.vue?vue&type=script&lang=ts&"
export * from "./ReportForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReportForm.vue?vue&type=style&index=0&id=22132950&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22132950')) {
      api.createRecord('22132950', component.options)
    } else {
      api.reload('22132950', component.options)
    }
    module.hot.accept("./ReportForm.vue?vue&type=template&id=22132950&", function () {
      api.rerender('22132950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/report/ReportForm.vue"
export default component.exports